import { ActionTree } from 'vuex';
import { State } from './state';
import IFilter, { IFilterOption } from '../models/filter-model';
import IPanel from '../models/panel-model';
import HttpService from "@/shared/services/http-service";

export default <ActionTree<State, any>>{
    setSelectedFilter({ commit,dispatch }, payload: { filter: IFilter, filterOption: IFilterOption }) {
        if (payload.filter.filterType==='single')
        {
          commit("resetFilterOptions", {filterCode: payload.filter.code});
        }      
        commit("toggleFilterOptionChecked",{filterCode: payload.filter.code, filterOptionCode: payload.filterOption.code } );
        dispatch('setPanelActiveStates');
    },

    loadData({ commit, state, dispatch }) {
        state.panelFilterWidgetService.getPanelFilterWidget(state.config.codename, HttpService)
        .then((values) => {
            //hack: convert filterType to lowercase
            values.filters.forEach((element, index) => {
                element.filterType=element.filterType.toLowerCase();
              });
          dispatch("setData", {
            labels: values.labels,
            filters: values.filters,
            panels: values.panels, 
          });
        })
        .catch((error) => {
          commit('setError', 
            // this.config.language === 'nl' ?
            //'Er gaat iets fout, probeer het later nog een keer' :
               'Something went wrong, please try again later'
             );
        })
        .finally(() => commit("setLoading", false));
    },

    setData({ commit, dispatch }, payload: { labels: {}, filters: IFilter[], panels: IPanel[] }) {
        commit("setFilters", payload.filters);
        commit("setPanels", payload.panels);
        commit("setLabels", payload.labels);
        commit("setInitialLoad", false);
        commit("setLoading", false);
        commit("clearSelectedFilterOptions");
        dispatch("setPanelActiveStates");
    },

    ///
    // On each Panel: set the isActive propert to true or false, based on the selected filter options
    ///
    setPanelActiveStates({ state, commit }) {
        state.panels.forEach((panel, index) => {
            console.log('================================');
            console.log('Checking active state for ' + panel.title);
            var newVal = !panel.filterOptions ? true : panel.filterOptions.every(panelOptions => {

                var filter = state.filters.find(filter => filter.code == panelOptions.filterCode);
                if (!filter || !filter.options || filter.options.filter(o => o.checked).length === 0) {
                    console.log(filter?.title + ' not set - true');
                    return true; // filter not set (config error at Panel) so include all
                }
                var selectedOptions = filter.options.filter(option => option.checked).map(option => option.code);
                if (filter.filterType === 'single') {
                    console.log(filter?.title + ' single ('+selectedOptions[0]+') - (' + panelOptions.values.join(',') +')' + panelOptions.values.includes(selectedOptions[0]));
                    //for single select filters, the value should be in the options of the panel
                    return panelOptions.values.includes(selectedOptions[0]);
                }
                else {
                    console.log(filter?.title + ' multi (' + selectedOptions.join(',') + ') - (' + panelOptions.values.join(',') +')' + selectedOptions.every(selectedOption => panelOptions.values.includes(selectedOption)));
                    //for multi select filters, all selected filter items must be in the value of the panel
                    return selectedOptions.every(selectedOption => panelOptions.values.includes(selectedOption));
                }
            });
            console.log('setting' + panel.title + ' to ' + newVal);
            commit("setPanelActiveState", { panel: panel, isActive: newVal });
        });
    }
}
